import { Box } from '@mui/material'
import { Divider, EmphasizedNumber, MenuListItem } from 'utoniq-ui'

import { GachaTicketOrderBoxFragment } from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { Cell } from '@/core/architecture'

type TicketOrderProps = {
  gachaTicketOrder: GachaTicketOrderBoxFragment
}
export const TicketHistoryItem: Cell<TicketOrderProps> = ({
  gachaTicketOrder: { formattedCreatedAt, count, title },
}) => {
  const { t } = useTranslation('ticketOrders')
  return (
    <>
      <MenuListItem
        disableTouchRipple
        component={Box}
        sx={{
          px: 5,
          py: 4,
          height: 'auto',
          cursor: 'initial',
          '&:hover': { backgroundColor: 'transparent' },
        }}
        title={t(`${title}`)}
        subTitle={formattedCreatedAt}
        primaryTypographyProps={{
          variant: 'h6',
        }}
        secondaryTypographyProps={{
          variant: 'overline',
          color: 'text.hint',
        }}
        secondaryAction={
          count > 0 ? (
            <EmphasizedNumber variant="h5" color="primary.main">
              {'+' + count}
            </EmphasizedNumber>
          ) : (
            <EmphasizedNumber variant="h5" color="text.secondary">
              {count}
            </EmphasizedNumber>
          )
        }
      />
      <Divider
        sx={{
          width: 'calc(100% - 40px)',
          ml: 6,
        }}
      />
    </>
  )
}
